import React, { useState, useEffect } from 'react';
import { Input, AutoComplete, Row, Spin } from 'antd';
import axios from 'axios';
import { options } from '../../utils/searchOptions';
import LazyCard from './Sections/LazyCard';

const { Search } = Input;

function LandingPage() {
  const [query, setQuery] = useState('짤');
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [start, setStart] = useState(1);
  const [hasMore, setHasMore] = useState(false);

  const renderCards = images.map((image) => {
    return <LazyCard image={image} key={image.id} />;
  });

  const getItems = () => {
    setLoading(true);
    axios
      .get(
        `https://www.googleapis.com/customsearch/v1?key=${process.env.REACT_APP_GOOGLE_API_KEY}&cx=${process.env.REACT_APP_GOOGLE_ENGINE_ID}&q=${query}&searchType=image&imgSize=medium&start=${start}`
      )
      .then((response) => {
        const array = [];
        response.data.items.forEach((item) => {
          array.push({
            link: item.link,
            id: item.image.byteSize + Date.now(),
          });
        });
        setImages((oldImages) => {
          if (start === 0) {
            return array;
          } else {
            return [...oldImages, ...array];
          }
        });
        if (response.data.queries.nextPage) {
          setHasMore(true);
        } else {
          setHasMore(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setHasMore(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (start > 61) {
      setHasMore(false);
      return false;
    } else {
      getItems();
    }
    // eslint-disable-next-line
  }, [start]);

  useEffect(() => {
    const event = window.addEventListener('scroll', () => {
      if (
        !loading &&
        window.innerHeight + window.scrollY >= document.body.scrollHeight - 2
      ) {
        setStart((oldCount) => {
          return oldCount + 10;
        });
      }
    });
    return () => window.removeEventListener('scroll', event);
    // eslint-disable-next-line
  }, []);

  const onSelectHandler = (data) => {
    setQuery(data);
    setStart(0);
    getItems();
  };

  const onChangeHandler = (data) => {
    setQuery(data);
  };

  const onSearchHandler = () => {
    setStart(0);
    getItems();
  };

  return (
    <div style={{ maxWidth: '1200px', margin: '3rem auto', height: 'auto' }}>
      <div>
        <AutoComplete
          style={{ width: '100%' }}
          options={options}
          onSelect={onSelectHandler}
          onChange={onChangeHandler}
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          value={query}
        >
          <Search
            placeholder='검색어를 입력하세요'
            enterButton='Search'
            size='large'
            loading={loading}
            onSearch={onSearchHandler}
          />
        </AutoComplete>
        {/* Grid-Cards */}
        <div style={{ marginTop: '100px' }}>
          <Row gutter={[16, 16]}>{renderCards}</Row>
          {hasMore ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Spin size='large' tip='Loading...' />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
